"use strict";

exports.__esModule = true;
exports.default = void 0;

var _polished = require("polished");

var _pallette = _interopRequireDefault(require("./pallette"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Styled-components theme for Reassure-UI document components
 */
const {
  white,
  midBlue,
  darkBlue,
  midGreen
} = _pallette.default;
var _default = {
  colors: {
    pdfViewer: {
      background: midBlue,
      toolbar: {
        text: white,
        background: (0, _polished.rgba)(darkBlue, 0.95),
        icons: midGreen,
        separators: (0, _polished.rgba)(white, 0.2)
      }
    }
  }
};
exports.default = _default;